import React from "react";
import styled from "styled-components";

export const withForm = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => (props: P) => (
  <Form>
    <WrappedComponent {...props} />
  </Form>
);

const Form = styled.form`
  position: relative;
`;

export const FormGroup = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-bottom: ${(props: any) =>
    props.fieldType === "radio" ? 0 : props.theme.spacing.desktop.s200}px;
  label {
    margin-right: ${(props: any) => props.theme.spacing.desktop.s500}px;
    &:last-child {
      margin-right: 0;
    }
  }
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    ${(props: any) =>
      props.fieldType === "radio"
        ? `flex-direction: row;`
        : `flex-direction: column;
                    label {
                        margin-right: 0;
                    }`}
  }
`;

export const FormStatic = styled.div`
  flex: none;
  font-size: ${(props: any) => props.theme.typography.h200};
  line-height: ${(props: any) => props.theme.typography.h700};
  width: 100%;
  a {
    font-weight: 600;
  }
`;
